import { Component } from '@angular/core'
import { RouterLink } from '@angular/router'
import {Input as RouteParam} from '@angular/core'
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-chantier-unauthorized',
    templateUrl: './chantier-unauthorized.component.html',
    imports: [RouterLink, NgIf],
})
export class ChantierUnauthorizedComponent {
  @RouteParam()
  codeChantier: string
}
